import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as partnerApi from '../../lib/api/partner';

const [VIEW_PARTNER, VIEW_PARTNER_SUCCESS, VIEW_PARTNER_FAILURE] =
  createRequestActionTypes('partner/VIEW_PARTNER');
export const viewPartner = createAction(VIEW_PARTNER, (id) => id);
const viewPartnerSaga = createRequestSaga(VIEW_PARTNER, partnerApi.getPartner);

const UNLOAD_PARTNER = 'partner/UNLOAD_PARTNER';
export const unloadPartner = createAction(UNLOAD_PARTNER);

const SET_PARTNER = 'partner/SET_PARTNER';
export const setPartner = createAction(SET_PARTNER, (partner) => partner);

export function* partnerSaga() {
  yield takeLatest(VIEW_PARTNER, viewPartnerSaga);
}

const initialState = {
  partner: null,
  error: null,
};

const partner = handleActions(
  {
    [VIEW_PARTNER_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      partner: data.info,
    }),
    [VIEW_PARTNER_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [UNLOAD_PARTNER]: () => initialState,
    [SET_PARTNER]: (state, { payload: partner }) => ({
      ...state,
      partner: partner,
    }),
  },
  initialState,
);

export default partner;
